export enum DocumentTypes {
  RecuperarProgramaciones = 0,
  Contratos = 1,
  PrevisionDemanda = 2,
  SLATR = 3,
  MSATR = 4,
  OperacionesSAP = 5,
  CanonesSAP = 6,
  CargaCisterna = 7,
  SPLG_DP = 8,
  ConciliacionMSATR = 9,
  SLATR_Respuesta = 10,
  MSATR_Respuesta = 11,
  SPLG_FP = 12,
  EvR = 13,
  D03 = 14,
  D06 = 15,
  D07 = 16,
  D08 = 17,
  D13 = 18,
  EvR_DP = 19,
  B80 = 20,
  B70 = 21,
  EvR_FP = 22,
  ConsultaOpMSATR = 23,
  A7 = 24,
  CalidadGas = 25,
  SPLG_FD = 26,
  EnvioTSO = 27,
  RespuestaEnvioTSO = 28,
  StorageParticipantActivityReport = 29,
  StandardContractTable1 = 30,
  GN15dic08 = 31,
  C52008 = 32,
  C42008 = 33,
  FacturaCliente = 34,
  PrevisionDemanda_DP = 35,
  PrevisionDemanda_FP = 36,
  A1 = 38,
  Demanda_Balance = 39,
  Demanda_Cisternas = 40,
  PscDiarioMuni = 41,
  A2 = 42,
  A3 = 43,
  A4 = 44,
  P2 = 48,
  Nominacion_Cliente = 49,
  Contractual = 50,
  BAD = 51,
  ProgramaOperativo = 52,
  Manual = 53,
  LngActivityReport = 54,
  LngPlannedUsageReport = 55,
  NonStandardContractTable2 = 56,
  H1_REAL = 57,
  H1_ESTIMADO = 58,
  CargaIndices = 59,
  F1 = 60,
  Q1 = 61,
  P1 = 62,
  F5D = 63,
  P5D = 64,
  CN = 65,
  SALD = 66,
  CargaOperacionesCV = 82,
  SPLG_BAD = 83,
  A2S = 84,
  A3S = 85,
  A4S = 86,
  A25 = 87,
  A26 = 88,
  TablaMaestra = 89,
  Repartos_PR_PCCC = 90,
  DemandaGNL = 91,
  CargaOperacionesCVV2 = 92,
  Escenarios_Prevision_Largo_Plazo = 93,
  Datos_Históricos_Prevision_Largo_Plazo = 94,
  Datos_Estaticos = 95,
  Carga_Prevision_Largo_Plazo = 96,
  Temperatura_AEMET = 97,
  Temperatura_AEMET_Prevista = 98,
  Temperatura_BAD = 99,
  Temperatura_Ponderada_BAD = 100,
  Prevision_CP_Historico = 101,
  Prevision_CP_BAD = 102,
  F1_CCP = 103,
  Paso_01 = 104,
  Paso_02 = 105,
  Paso_03 = 106,
  Paso_04 = 107,
  Paso_05 = 108,
  Paso_06 = 109,
  Paso_07 = 110,
  Paso_08 = 111,
  Paso_09 = 112,
  Paso_10 = 113,
  Paso_11 = 114,
  Paso_12 = 115,
  Paso_13 = 116,
  A7_kWh = 117,
  CargaPrecios = 118,
  F2_CCPP = 119,
  F3_CSSGN = 120,
  F4_CGN = 121,
  CargaMedidas = 122,
  ESCILA = 123,
  FNEE = 124,
  PRICE = 125,
  TradesTemplate = 126,
  CODAGE_E = 127,
  CODAGE_G = 128,
  Fichero4_G = 129,
  Fichero1_G = 130,
  CustomerTemplates = 131,
  SCTD_G_INFORME_ListadoPCTD = 132,
  Captacion_Listado_Clientes = 133,
  SPLG_Detalle_DP = 134,
  SPLG_Detalle_FP = 135,
  MedidasCeltica = 136,
  ClientesEleia = 137,
  PriceComponentTemplate = 138,
  NominacionPPA = 139,
  Facturae = 140,
  PFinalREE = 141,
  FlexibilityTemplate = 142,
  Compodem = 143,
  Extrapeninsular = 144,
  Kestimado = 145,
  BAD_HUB = 146,
  Prevision_N = 147,
  Prevision_N_menos_1 = 148,
  CartaConformidadGas = 149,
  ActaPuestaMarchaGas = 150,
  ActaInspeccionGas = 151,
  ReclamacionGas = 152,
  RespuestaReclamacionGas = 153,
  FacturasGas = 154,
  OtraDocumentacionClienteGas = 155,
  DeclaracionResponsableGas = 156,
  OtrosGas = 157,
  CIEConsumoPWR = 158,
  ActaPuestaMarchaPWR = 159,
  ActaInspeccionPWR = 160,
  ReclamacionPWR = 161,
  RespuestaReclamacionPWR = 162,
  FacturasPWR = 163,
  OtraDocumentacionClientePWR = 164,
  OtrosPWR = 165,
  AcuerdoRepartoPWR = 166,
  CIEGeneracionPWR = 167,
  DeclaracionPuntosRecargVEAccesoPublicoPWR = 168,
  FicheroCoeficientesRepartoPWR = 169,
  CertificadoSueloUrbanizadoPWR = 170,
  RenunciasCapacidad = 171,
  Paso_16 = 179,
  Paso_14 = 183,
  Paso_15 = 184,
  Paso_Manual = 185,

  A28 = 203,
  A29 = 204,

  Template = 999
}
